import React from 'react';
import { ContentBlock } from 'seduo-ui';
const Example = () => (<ContentBlock>
        <div>Anything on block</div>
    </ContentBlock>);
export default Example;
